/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["pituna pyterupé", "iandé-ara-pyturepé", "kuêma ramẽ", "karuka ramẽ", "pituna ramẽ", "pitunaeté ramẽ"], u, u], u, ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "19:00"], ["19:00", "24:00"], ["00:00", "06:00"]]];
